import { FC, ReactNode } from "react";
import { SocketContext } from "./SocketContext";
import { OverlaySocket } from "@ailenax-overlay/shared";
import { io } from "socket.io-client";
import { useAuth } from "@/hooks/useAuth";
import customParser from "socket.io-msgpack-parser";
import { useNavigate } from "react-router-dom";

export const WebSocketProvider: FC<{ children: ReactNode }> = ({ children }) => {
    const { token } = useAuth();
    const navigate = useNavigate();

    console.log("Connecting to socket", token);

    const socket: OverlaySocket = io(import.meta.env.VITE_OVERLAY_URL, {
        parser: customParser,
        auth: {
            token
        }
    });

    socket.on("connect_error", (e) => {
        if (e.message === "Authentication error") {
            navigate("/login");
        }
    })
    
    socket.on("reload-overlay", () => {
        window.location.reload();
    });
    
    return <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>;
}